/* eslint-disable prettier/prettier */
import { colors } from '&assets/constants/colors';
import { device } from '&assets/constants/responsiveness';
import styled from 'styled-components';

export const WhatWeDoWrapper = styled.div`
	max-height: fit-content;
	box-sizing: border-box;
	width: 100%;
	background-color: ${colors.primary};
	.content {
		height: 100%;
		padding: 50px 0px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		.left-section {
			height: 100%;
			margin-right: 20px;
			display: flex;
			flex-direction: column;
			align-items: start;
			justify-content: space-between;
			.title {
				color: ${colors.white};
				font-size: 68px;
				font-family: 'Segnifier-Bold';
				font-weight: bold;
				margin: 0;
				margin-bottom: 24px;
			}
			.description {
				color: #fff;
				font-size: 1.5em;
				font-style: normal;
				font-weight: 400;
				line-height: 34px; /* 170% */
				letter-spacing: -0.6px;
				margin: 0;
			}
		}
		.right-section {
			.sub-title {
				font-size: 45px;
				line-height: 3.5rem;
				color: ${colors.white};
			}
		}
	}
	@media ${device.tablet} {
		.content {
			padding: 20px;
		}
	}

	@media ${device.mobile} {
		.content {
			flex-direction: column;
			padding: 20px;
			.left-section {
				width: 100%;
				margin-right: 0;
				.title {
					font-size: 2.5rem;
					margin-bottom: 30px;
				}
			}
			.right-section {
				width: 100%;
				.sub-title {
					margin-top: 30px;
					font-size: 1.2rem;
					line-height: 1.5rem;
				}
			}
		}
	}
`;
